import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateChatContentDto } from "@/dto/ChatContentDto";
import { superChatContentApi } from "@/apis/superChatContent";
import Router from "@/constants/router";

/**
 * 채팅 컨텐츠 생성 페이지 Hook
 * @description 채팅 컨텐츠 생성 로직을 관리합니다.
 * @author Max <sud665@ymjlab.com>
 * @version 1.0.0
 * @since 2025-01-16
 */
export default function useCreateContent() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  /**
   * 컨텐츠 생성 제출 핸들러
   */
  const handleSubmit = async (data: CreateChatContentDto) => {
    setIsLoading(true);
    try {
      console.log("[CREATE_CONTENT]", {
        action: "submit",
        data,
        timestamp: new Date().toISOString(),
      });

      // API 호출로 컨텐츠 생성
      const result = await superChatContentApi.create(data);

      console.log("[CREATE_CONTENT]", {
        action: "success",
        message: "컨텐츠가 성공적으로 생성되었습니다.",
        result,
      });

      // 성공 시 목록 페이지로 이동
      navigate(Router.SuperChatContent);
    } catch (error: any) {
      console.error("[CREATE_CONTENT]", {
        action: "error",
        error: error.message,
        data,
      });

      // 에러 처리
      alert(`컨텐츠 생성 실패: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    handleSubmit,
  };
}
